import React, { Component } from "react";

export default class PrivacyPolicy extends Component {
  render() {
    return (
      <div className="container">
        <div className="content pure-u-1">
          <h1>Privacy Policy</h1>

          <p>
            This policy applies to all information collected or submitted on
             윈윈디베이트(winwindebate)’s website and our apps for iPhone and
            any other devices and platforms.
          </p>

          <h2>Information we collect</h2>

          <p>
            When creating an account, you will be asked to enter an optional
            email address and a password. Email addresses are{" "}
            <strong>only</strong> used for logging in, password resets,
            responding to emails that you initiate, and notifications that you
            request. We don’t send promotional emails.
          </p>

          <p>
            You may choose <strong>not</strong> to provide an email address and
            have an anonymous sync account instead.
          </p>

          <p>
            We store information about your activities to sync this information
            between the website and your devices. We also collect anonymous
            statistics about which activities are most popular to help inform
            our recommendation engine.
          </p>

          <h3>
            <strong>Technical basics</strong>
          </h3>

          <p>
            We use cookies on the site and similar tokens in the app to keep you
            logged in. Our server software may also store basic technical
            information, such as your IP address, in temporary memory or logs.
          </p>

          <h3>
            <strong>Ads and analytics</strong>
          </h3>

          <p>
             윈윈디베이트(winwindebate)’s app collects aggregate, anonymous
            statistics, such as the percentage of users who use particular
            features, to improve the app.
          </p>

          <p>
            No personal data is used to target  윈윈디베이트(winwindebate)’s ads
            except the categories of podcasts that you’re subscribed to, such as
            “Technology” or “Business”. Each ad collects, and shares with its
            advertiser, only three numbers: total views, total taps, and total
            subscriptions from the ad.
          </p>

          <h2>Information usage</h2>

          <p>
            We use the information we collect to operate and improve our
            website, apps, and customer support.
          </p>

          <p>
            We do not share personal information with outside parties except to
            the extent necessary to accomplish  윈윈디베이트(winwindebate)’s
            functionality. We may share anonymous, aggregate statistics with
            outside parties, such as how many people participate to a particular
            course with  윈윈디베이트(winwindebate).
          </p>

          <p>
            We may disclose your information in response to legal requirements;
            to exercise our legal rights or defend against legal claims; to
            investigate, prevent, or take action regarding illegal activities,
            suspected fraud or abuse, violations of our policies; or to protect
            our rights and property.
          </p>

          <p>
            In the future, we may sell to, buy, merge with, or partner with
            other businesses. In such transactions, user information may be
            among the transferred assets.
          </p>

          <h2>Security</h2>

          <p>
            We implement a variety of security measures to help keep your
            information secure. For instance, all communication with the app and
            website requires HTTPS with certificate pinning. Passwords are{" "}
            <a href="http://en.wikipedia.org/wiki/Cryptographic_hash_function">
              hashed
            </a>
            , not stored, using industry-standard methods (currently{" "}
            <a href="https://firebase.google.com/">firebase authentication</a>).
          </p>

          {/* <h2>Accessing, changing, or deleting information</h2>

          <p>
            You may access or change your information or delete your account
            from the  윈윈디베이트(winwindebate) iOS app.
          </p>

          <p>
            Deleted information may be kept in backups for up to 90 days.
            Backups are encrypted and are only accessed if needed for disaster
            recovery.
          </p>

          <p>
             윈윈디베이트(winwindebate) may delete your information at any time
            and for any reason, such as technical needs, legal concerns, abuse
            prevention, removal of idle accounts, data loss, or any other
            reason.
          </p> */}

          {/* <h2>Third-party links and content</h2>

          <p>
             윈윈디베이트(winwindebate) displays links and content from
            third-party podcast feeds and sites, and downloads podcast files
            directly from each podcast’s third-party servers. These have their
            own independent privacy policies, and we have no responsibility or
            liability for their content or activities.
          </p> */}

          <h2>California Online Privacy Protection Act Compliance</h2>

          <p>
            We comply with the California Online Privacy Protection Act. We
            therefore will not distribute your personal information to outside
            parties without your consent.
          </p>

          <h2>Children’s Online Privacy Protection Act Compliance</h2>

          <p>
            We never collect or maintain information at our website from those
            we actually know are under 13, and no part of our website is
            structured to attract anyone under 13.
          </p>

          <h2>Information for European Union Customers</h2>

          <p>
            By using  윈윈디베이트(winwindebate) and providing your information,
            you authorize us to collect, use, and store your information outside
            of the European Union.
          </p>

          <h2>International Transfers of Information</h2>

          <p>
            Information may be processed, stored, and used outside of the
            country in which you are located. Data privacy laws vary across
            jurisdictions, and different laws may be applicable to your data
            depending on where it is processed, stored, or used.
          </p>

          <h2>Your Consent</h2>

          <p>By using our site or apps, you consent to our privacy policy.</p>

          <h2>Contacting Us</h2>

          <p>
            If you have questions regarding this privacy policy, you may email{" "}
            <a href="mailto:stringee@gmail.com">stringee@gmail.com</a>.
            {/* Please
            note that account deletion should be done within the
             윈윈디베이트(winwindebate) app, not via email requests, for
            security reasons. */}
          </p>
        </div>
      </div>
    );
  }
}
